import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility,grid } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { getStatus } from '../../utilities/orgUtilities';
import { decodeEntities,checkFormLock } from '../../utilities/formsUtilities';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInConditionals } from '../Utilities/AllInConditionals';
import { AllInLocationsBase } from '../Utilities/AllInLocationsBase';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
//import arrowUrl from '../../../../../../assets/arrow.svg?url';

export class AllInLocations extends AllInLocationsBase(AllInConditionals(AllInSessionStorage(AllInOrganisationConsumer(LitElement)))) {
    static properties = {
        ...super.properties,
        _loading: { state:true,type: Boolean },
        _locationData: { state:true,type: Array },
        _isApproved: { state:true,type: Boolean },
        //_hasZones: {state:true,type: Boolean},
    }

    constructor() {
        super();
        this._loading = true;
        //this._hasZones = true;
    }

    async connectedCallback() {
        super.connectedCallback();
        this._loading = true;
        if(this.organisation?.hasOwnProperty('locations')){
            this._locationData = this.organisation.locations;
            this._loading = false;
        }
        else if(this.currentOrg){
            this._maybeGetLocationsFromSessionStorage();
            if(!this.organisation?.locations||this.organisation.locations.length==0){
                await this._fetchLocations();
            }
            else{
                this._fetchLocations();
            } 
            this._locationData = this.organisation.locations;
            this._loading = false;
        }
        if(!this.provisions?.length){
            this._getProvisionsFromSessionStorage();
            if(!this.provisions?.length){
                await this._fetchProvisions();
            }
        }
        if(this.organisation?.hasOwnProperty('locations')&&this.provisions?.length){
            this._loading = false;
        }
        this._isApproved = this.organisation?.approvalStatus=='Approved';
        this._subscriptionTier = this.organisation?.subscriptionTier?this.organisation.subscriptionTier:'Tier1';
        this._subscriptionTotalLocations = this.organisation?.subscriptionTotalLocations?this.organisation.subscriptionTotalLocations:1;
        this._subscriptionExpired = this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) < new Date();
        this._isPilot = this.organisation?.pilot;
        this._locationCount = this._locationData?.length||0;
        this.renderRoot.querySelector('button,a')?.focus();
        cardLinks(this.shadowRoot);
        if(this.currentOrg && this._isAdmin()){
            this._fetchInvoices();
        }
    }
    
    disconnectedCallback(){
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }


    render() {
        let main='';
        if(this._loading){
            main = html`<allin-loader loading></allin-loader>`;
        }else{
            let cards = html`<p>${msg(str`No locations have been added yet`)}</p>`;
            let buttonString = msg(str`Add a location`);
            let notification = '';
            if(this._invoices){

                let unpaidInvoices = this._invoices?.data?.filter((invoice)=>invoice.status=='open');
                if(unpaidInvoices?.length>0){
                    notification = html`<div class="message">
                        <h4>${msg(str`You have ${unpaidInvoices.length==1?'an ':''}unpaid invoice${unpaidInvoices.length==1?'':'s'}`)}</h4>
                        <ul>
                           ${unpaidInvoices.map((invoice)=>html`
                            <li>
                                ${msg(str`You have an unpaid invoice. Please make the payment in order to unlock the subscription benefits.`)} 
                                <a href="${invoice.hostedInvoiceUrl}" target="_blank" rel="noopener">
                                    ${msg(str`View invoice`)}
                                </a>
                            </li>`)}
                        </ul>
                    </div>`
                }
            }
            if(this._locationData?.length){
                
                buttonString = msg(str`Add another location`);
                cards = html`
                    <ul>
                        ${this._locationData.map((location)=>{
                            let name = decodeEntities(location.name);
                            let id = location.id;
                            let in_progress = location.in_progress;
                            let isLocked = location.isLocked;
                            location = location.location_data;
                            if(!location) return;
                            let status = location.approvalStatus?getStatus(location.approvalStatus):'';
                            let accessInfo = '';
                            if(location?.accessInformation){
                                accessInfo = this._processAccessInfo(location.accessInformation);
                            }
                            let imageName;
                            for(let i=1;i<4;i++){
                                if(location[`photo${i}`]){
                                    imageName = `photo${i}`;
                                    break;
                                }
                            }
                            let image = location[imageName]?location[imageName]:'';
                            let path = image?location[imageName].publicUrl:'';
                            let alt = image?location[imageName].altText:'';
                            let notices = location.declineMessage?html`<div class="notices">
                                    <span class="screen-reader-text">
                                        ${location.declineMessage?msg(str`You have a notice relating to ${organisation.name}`):''}
                                    </span>
                                    <span aria-hidden="true" >${location.declineMessage?'1':''}</span>
                                </div>`:'';
                            let buttonGroup = html`
                                <div class="button-group">
                                    <a href="javascript:void(0)" data-location_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleLocationClick}>${msg(str`View location`)}</a>
                                    <a href="javascript:void(0)" data-location_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleLocationDetailsClick}>${msg(str`Manage details`)}</a>
                                </div>
                            `; 
                            if(location.approvalStatus=='AwaitingResponse'){
                                buttonGroup = html`
                                <div class="button-group">
                                    <a href="javascript:void(0)" data-location_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleLocationClick}>${msg(str`View location`)}</a>
                                </div>
                            `; }
                            
                            if(in_progress&&location.approvalStatus=='NewApplication'){
                                console.log(location.approvalStatus);
                                status = msg(str`New application in progress`);
                                if(isLocked){
                                    buttonGroup = html`
                                    <div class="button-group">
                                        <p >${msg(str`This form is currently being edited by someone else`)}</p>
                                    </div>
                                    `; 
                                }
                                else{
                                    buttonGroup = html`
                                    <div class="button-group">
                                        <a href="javascript:void(0)" class="button" @click=${this._handleAddLocationClickContinue} data-locid="${id}" data-ppage="${in_progress}">${msg(str`Complete saved form`)}</a>
                                    </div>
                                    `; 
                                }
                            }
                            let inlineNotice = '';
                            if(location.approvalStatus=='Rejected'){
                                inlineNotice = location.declineMessage?html`<div class="notices">
                                    <p>${location.declineMessage}</p>
                                </div>`:'';
                                buttonGroup = '';
                                notices = '';
                            }
                            let zones = location.zones;
                            let zonesText = '';
                            if(location.approvalStatus == "Approved") {
                                let hasInProgressZones = zones.some(zone => zone.in_progress);
                                let hasActiveSubscription = this.organisation.subscriptionTier && this.organisation.subscriptionTier !== 'Tier1' && !this._subscriptionExpired;
                                zonesText = html`
                                    <div class="content-zones">
                                        <h4>Zones</h4>
                                        <ul class="zone-list">
                                            ${zones.map((zone, index) => {
                                                let link;
                                                let status  = getStatus(zone.approvalStatus);
                                                if(zone.in_progress){
                                                    link = html`<a href="${this.hardlinks.organisation_dashboard_add_zone}?org_id=${this.currentOrg}&location_id=${id}&in_progress=${zone.id}&ppage=${zone.in_progress}">${msg(str`Complete your zone setup`)}</a>`;
                                                }
                                                else {
                                                    link = html`<a href="javascript:void(0)" data-zone_id="${zone.id}" data-location_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleZoneClick}>${msg(str`Manage`)}</a>`;
                                                }
                                                return html`
                                                <li>
                                                   ${zone.name} 
                                                   ${status ? html`<span class="message small">${status}</span>` : ''}
                                                   ${link}
                                                </li>
                                            `}
                                            )}
                                        </ul>
                                        ${!hasInProgressZones&&hasActiveSubscription ? html`
                                            <div class="button-group">
                                                <a href="${this.hardlinks.organisation_dashboard_add_zone}?org_id=${this.currentOrg}&location_id=${id}">${zones.length?msg(str`Add another zone`):msg(str`Add a zone`)}</a>
                                            </div>
                                        ` : ''}
                                        ${!hasActiveSubscription ? html`
                                            <div class="message small">
                                                <p>${msg(str`Zones are available for organisations on an active subscription plan. Please upgrade your subscription to access zone features.`)}</p>
                                                <br>
                                                <button class="button" @click=${()=>this._updateContext({dashboard:'subscriptions',panel:null,view:null})}>${msg('View subscription options')}</button>
                                            </div>
                                        ` : ''}
                                    </div>
                                `;
                            }

                            if(this._subscriptionTier !== "Tier1"){
                                let displayLocPublishedStatus;
                                if(location.approvalStatus == "AwaitingResponse") {
                                    displayLocPublishedStatus = html`
                                        <p class="published-status small">${msg(str`Awaiting approval`)}</p>
                                    `
                                }
                                else if(location.approvalStatus == "NewApplication") {
                                    displayLocPublishedStatus = html`
                                        <p class="published-status small">${msg(str`New application`)}</p>
                                    `
                                }   
                                else {
                                    displayLocPublishedStatus = html`
                                        <p class="published-status small">
                                            ${location.publishedStatus === 'Published' ? 'Published' : 'Unpublished'}
                                        </p>
                                    `
                                }
                                return html`
                                    <li class="bg location-card card">
                                        <img src="${path}" alt="${alt}">
                                        <div class="content">
                                            <h4>${name}</h4>
                                            ${displayLocPublishedStatus}
                                            <p class="semibold">${accessInfo}</p>
                                            ${buttonGroup}
                                            ${inlineNotice}
                                            ${zonesText}
                                        </div>
                                        ${/*commented this out temporarily to remove 1 appearing inside the DOM*/ ''}
                                        ${/*${notices}*/ ''}
                                    </li>
                                `
                            }else{
                                return html`
                                    <li class="bg location-card card">
                                        <img src="${path}" alt="${alt}">
                                        <div class="content">
                                            <h4>${name}</h4>
                                            <p class="message small ${location.approvalStatus.toLowerCase()}">${msg(str`Please subscribe to an Essentials or Plus account to publish your location.`)}</p>
                                            <p class="semibold">${accessInfo}</p>
                                            ${buttonGroup}
                                            ${inlineNotice}
                                            ${zonesText}
                                        </div>
                                        ${/*commented this out temporarily to remove 1 appearing inside the DOM*/ ''}
                                        ${/*${notices}*/ ''}
                                    </li>
                                `
                            }
                        })}
                    </ul>
                `;
            }
            let button = ``;
            if(this._isApproved){
                if(this._subscriptionTotalLocations<=this._locationCount){
                    button = '';
                }else{
                    button = html`<a href="javascript:void(0)" class="button" @click=${this._handleAddLocationClick}>${buttonString}</a>`;
                }
            }
            main =  html`
                <div class="grid">
                    <h3>${decodeEntities(this.organisation?.name??'')} ${msg(str`locations and zones`)}</h3>
                    ${cards}
                    ${button}
                </div>
            `;
        }
        return html`${main}`;
    }

    _getOrganisationById(id){
        return this.organisations.find((org)=>org.org_id==id);
    }

    
    
    
    _handleAddLocationClick(e){
        e.preventDefault();

        //prevent add location for expired subscriptions
        const isActive = this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) > new Date();

        const btnContainer = e.currentTarget.parentElement;

        // Remove existing error message if any
        const existingMsg = btnContainer.querySelector('.add-location-error');
        if (existingMsg) existingMsg.remove();

        if (!isActive&&this._subscriptionTier !== "Tier1") {
            // Append <p> below the button
            const p = document.createElement('p');
            p.className = 'add-location-error';
            p.textContent = 'Your subscription has expired. Please renew your subscription.';
            p.style.color = 'red';
            p.style.marginTop = '0.5rem';
            btnContainer.appendChild(p);
            return; // stop further action
        }

        this.eventManager.emit(`allin-organisation-${this.name}-switcher`,{dashboard:'locations',panel:`add`});
    }

    _handleAddLocationClickContinue(e){
        e.preventDefault();

        //prevent add location for expired subscriptions
        const isActive = this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) > new Date();

        const btnContainer = e.currentTarget.parentElement;

        // Remove existing error message if any
        const existingMsg = btnContainer.querySelector('.add-location-error');
        if (existingMsg) existingMsg.remove();
  
        if (!isActive&&this._subscriptionTier !== "Tier1") {
            // Append <p> below the button
            const p = document.createElement('p');
            p.className = 'add-location-error';
            p.textContent = 'Your subscription has expired. Please renew your subscription.';
            p.style.color = 'red';
            p.style.marginTop = '0.5rem';
            btnContainer.appendChild(p);
            return; // stop further action
        }

        let id = e.target.dataset.locid;
        let ppage = e.target.dataset.ppage;
        window.location.href = `/organisation-dashboard/add-location?org_id=${this.currentOrg}&in_progress=${id}&ppage=${ppage}`;
    }

    _handleLocationClick(e){
        e.preventDefault();
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`,{dashboard:'locations',panel:`${e.target.dataset.location_id}`});
    }

    _handleLocationDetailsClick(e){

        this.eventManager.emit(`allin-organisation-${this.name}-switcher`,{dashboard:'locations',panel:`${e.target.dataset.location_id}`,view:'edit'});
    }

    // for handling zones
    _handleZoneClick(e){
        e.preventDefault();
        const zoneId = e.currentTarget.dataset.zone_id;
        const locationId = e.currentTarget.dataset.location_id;
        const orgId = e.currentTarget.dataset.org_id;
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`,{dashboard:'locations',panel:`${locationId}`,view:zoneId});
    }

    async _handleContextUpdate(value){
        let currentOrg = this.currentOrg;
        this.organisationData = value;
        ({currentOrg:this.currentOrg,name:this.name,restUrl:this.restUrl,organisations:this.organisations,action:this.action,nonce:this.nonce, user:this.currentUser,provisions:this.provisions} = this.organisationData);
        this.organisation = this._getOrganisationById(this.currentOrg);

        //  prevent navigating to the add location page when subscription is expired
        // if (this.organisation?.subscriptionEndDate) {
        //     const isActive = new Date(this.organisation.subscriptionEndDate) > new Date();

        //     if (!isActive) {
        //         window.location.href = `/organisation-dashboard/${this.currentOrg}/subscriptions/`;
        //         return; // stop everything
        //     }
        // }

        if(this.organisation?.hasOwnProperty('locations')){
            this._locationData = this.organisation.locations;
            if(this.provisions.length){
                this._loading = false;
            }
            else{
                await this._fetchProvisions();
            }
        }
        else if(this.currentOrg!== currentOrg && this.currentOrg){
            this._fetchLocations();
        }
    }

    _processAccessInfo(info){
        //info = JSON.parse(info);
        return '';
    }
    static styles = [
        accessibility,
        grid,
        css`
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
            margin-bottom:1rem;
            
        }
        @media screen and (min-width:700px){
            .bg{
                grid-template-columns: auto 1fr 2rem;
            }
        }
        .button{
            text-align:center;
        }
        .grid{
            gap:1.5rem;
        }
        
        .card a{
            display:block;
            padding:0rem;
            border-radius:0;
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            text-align:center;
            font-weight:700;
            text-decoration:underline;
            transition:color var(--transition) ease;
            height:fit-content;
            align-self:start;
            text-underline-offset: 6px;
        }

        .card:hover a{
            color:var(--allin-highlight-color-lighter,#5e3e7d);
        }

        .card a::after{
            content: "";
            display: inline-block;
            width: 21px;
            height: 15px;
            background: url('/wp-content/themes/ace/assets/arrow.svg') no-repeat center;
            background-size: cover;
            margin-left: 12px;
            transform: translateY(3px);
        }

        .content{
            display:grid;
            gap:0.5rem;
            padding: var(--allin-padding,2rem);
        }
        .content-zones{
            display:grid;
            gap:0.5rem;
            padding: 2rem 0 0;
        }
        .card img{
            object-fit:contain;
        }
        .bg.card.location-card {
            padding: 0;
        }
        .card.location-card img {
            object-fit: cover;
            width: 260px;
            height: 100%;
            aspect-ratio: 1;
        }
        h4,h3,p{
            margin:0;
        }

        .button-group{
            display:flex;
            /* justify-content:space-between; */
            gap:0.7rem;
            flex-direction: column;
        }

        .button-group button svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
    
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        ul li{
            display:grid;
            gap:0.5rem;
        }

        .button{
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            font-family:var(--allin-font-family,'Montserrat');
            background-color:var(--allin-button-bg-color,#472961);
            font-size:var(--allin-button-font-size,1rem);
            color:var(--allin-button-text-color,#fff);
            font-weight:(var(--allin-button-font-weight,600));
            cursor:pointer;
            border:none;
            text-decoration:none;
            transition:background-color var(--transition) ease;
        }

        ul.zone-list li{
            grid-template-columns: 1fr auto;
            border-top: 1px solid gray;
            border-bottom: 1px solid gray;
            padding: 0.5rem 0;
            font-weight: bold;

        }
        ul.zone-list li .message{
            grid-row: 2 / 3;
            grid-column: 1 / -1;
            font-weight: 400;
        }
        ul.zone-list li a {
            justify-self: end;
            font-size: 0.9rem;
        }
        ul.zone-list li a::after{
            content: none;
            background: none;
        }
        

        `
        ];
}

